import Head from "next/head";

const Analytics = ({ trackingCode }) => {
  return (
    <Head>
      <script
        type="text/plain"
        data-category="analytics"
        data-service="Google Analytics"
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${trackingCode}`}
      />
      <script
        type="text/plain"
        data-category="analytics"
        data-service="Google Analytics"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${trackingCode}');
          `,
        }}
      />
    </Head>
  );
};

export default Analytics;
